import script from "./ingredient-list-static.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredient-list-static.vue?vue&type=script&setup=true&lang=js"

import "./ingredient-list-static.vue?vue&type=style&index=0&id=9bd97114&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bd97114"]])

export default __exports__